import React from 'react';
import PropTypes from 'prop-types';
import TVWeeklySummaryPanel from './TVWeeklySummaryPanel';

function TVNextWeekPanel({ data, compact = false, loading = false }) {
  return <TVWeeklySummaryPanel data={data} compact={compact} loading={loading} />;
}

TVNextWeekPanel.propTypes = {
  data: PropTypes.object,
  compact: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TVNextWeekPanel;
